import { v1 as uuidv1 } from 'uuid';

export const DEFAULT_PREFIX:string = 'idPeticion';
export const getUUID = (idFront:string = '', prefix:string = DEFAULT_PREFIX, equalSignal:boolean = true):string => {
  const v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678,
  };

  let uuid = uuidv1(v1options);

  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  const res = `${prefix}${equalSignal ? '=' : ''}${idFront}${uuid}`;

  return res;
};

// To do this, you can create a SONDA, and then execute sonda.sondaEvent
export const sendJSError = (processName:string, method:string, data:string):void => {
  try {
    const dataToSend = JSON.stringify(data);

    if (window.IC && window.IC.trackErrorCtz) {
      window.IC.trackErrorCtz(processName, '', method, dataToSend);
    }
  } catch (err) {
    console.log('IC is not defined');
  }
};
